import Mock from 'mockjs';
import setupMock, { successResponseWrap } from '@/utils/setup-mock';

const customerList = Mock.mock({
  'list|60': [
    {
      'user_id|+1': 1000,
      'nickname': '@cname',
      'avatar': '@image("200x100")',
      'mobile': /^1[3456789]\d{9}$/,
      'bb_project':
        '@pick(["玻尿酸", "肉毒素", "水光针", "超声刀", "热玛吉", "激光", "射频", "微针", "水光针", "超声刀", "热玛吉", "激光", "射频", "微针"])',
      'city': '@city',
      'is_distribute': 0, // 默认值，会被动态覆盖
    },
  ],
});

setupMock({
  mock: false,
  setup() {
    Mock.mock(new RegExp('/tool/public_pool_list'), (options: any) => {
      // 解析请求参数
      const url = new URL(options.url, 'http://localhost');
      const isDistribute = url.searchParams.get('is_distribute');

      // 根据请求参数 is_distribute 设置返回数据的 is_distribute 值
      let targetValue = 1; // 默认值
      if (isDistribute === '0') {
        targetValue = 0;
      } else if (isDistribute === '1') {
        targetValue = 1;
      }

      const responseList = customerList.list.map((item: any) => ({
        ...item,
        is_distribute: targetValue,
      }));

      return successResponseWrap({
        list: responseList,
        total: responseList.length,
      });
    });
  },
});
